import React, {Component} from 'react';
import '../assets/css/Home.css';

class Delivery extends Component {
    render() {
        return (
            <div className="container partner-list">
                <h1 className="heading">Delivery Policy</h1>
                <hr/>
                <ul>
                    <li>
                        We only delivery within the <strong>Colombo</strong> city limits. Looking forward in expanding
                        our delivery locations.
                    </li>
                    <br/>
                    <li>
                        All orders will be delivered within <strong>3-4 days</strong> of ordering. We try our best to
                        ship all orders as soon as possible.
                    </li>
                    <br/>
                    <li>We reserve the right to modify these policies at any time.</li>
                </ul>
            </div>
        );
    }
}

export default Delivery;